// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bn-2";
export var aiChatCartContainerExit = "_bn-4";
export var aiChatContainerLarge = "_bn-0";
export var aiChatContainerSmall = "_bn-1";
export var aiChatIcon = "_bn-6";
export var slideInFromRight = "_bn-3";
export var slideOutToRight = "_bn-5";